import React from 'react';
import { Link } from 'react-router-dom';
import service from "../../assets/images/resource/fms2.png";

const ProductThree = () => {
    return (
        <section>
            <figure>
                <img src={service} alt="" />
            </figure>
            <h2><span>Mintegra</span> - Fleet Management System</h2>

            <p>
                <b>Mintegra</b> enables real time, in field data collection across the mine lifecycle using mobile devices. It answers the challenge of controlling your data and making it relevant to the business without exceeding IT budgets or creating large overheads.
            </p>

            <p>&nbsp;</p>

            <h3>Our Services</h3>
            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <li> <Link to="#">Fleet Management System</Link></li>
                </div>
                <div className="col-lg-12 col-md-12">
                    <li> <Link to="#">Communication & Network Management</Link></li>
                </div>
                <div className="col-lg-12 col-md-12">
                    <li> <Link to="#">Mining Operation Development System</Link></li>
                </div>
            </div>

            <p>&nbsp;</p>

            <h3>Our Solutions</h3>
            <div className="row">
                <div className="col-lg-6 col-md-12">
                    <li> <Link to="#">Tracking</Link></li>
                </div>
                <div className="col-lg-6 col-md-12">
                    <li> <Link to="#">Fleet Management & Operational</Link></li>
                </div>
                <div className="col-lg-6 col-md-12">
                    <li> <Link to="#">Plant / Equipment Maintenance</Link></li>
                </div>
                <div className="col-lg-6 col-md-12">
                    <li> <Link to="#">Human</Link></li>
                </div>
                <div className="col-lg-6 col-md-12">
                    <li> <Link to="#">Safety</Link></li>
                </div>
                <div className="col-lg-6 col-md-12">
                    <li> <Link to="#">Automation</Link></li>
                </div>
            </div>

        </section>
    )
}

export default ProductThree